<template>
  <div class="CouponGoodsList">
      <div class="couponGoodsList-head-con">
        <app-header class="couponsGoodList-head" @on-click="goBack"></app-header>
        <div class="couponGoodsList-head-bg">
            <div class="couponGoodsList-head-title">{{$t('coupons.applicable_to_the_following')}}</div>
        </div>
      </div>
      <div class="goodsList mt20">
            <div class="no-data" v-if="!couponGoodsList || !couponGoodsList.length">
                <img src="../../assets/imgs/login/noCoupons.png" alt="">
                <span class="tips-noData">{{$t('coupons.no_data')}}</span>
            </div>

            <flexbox>
                <template v-for="row in couponGoodsList">
                    <flexbox-item @on-item-click="itemClickHandler(row)" :key="row.dataList" :bg="row.item_bg">    
                        <img class="sign-icon" v-show="row.saleIconShow" :src="row.saleImageUrl" :style="row.iconStyle">
                        <div class="goodsList-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</div> 
                        <!-- <div>                                    
                            <div class="goodsList-name van-multi-ellipsis--l3 f16">{{ row.goodsName }}</div>
                        </div>                                                 -->
                        <div class="goodsList-price-box">
                            <div class="price">{{ row.goodsPriceText }}</div>
                            <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                        </div>
                    </flexbox-item>
                </template>                                                
            </flexbox>
      </div>
  </div>
</template>

<script>
import Flexbox from '../packages/components/flexbox/flexbox'
import FlexboxItem from '../packages/components/flexbox/flexboxItem'
import normal_bg from '../../assets/imgs/normal@3x.png'
import unlimited_bg from '../../assets/imgs/unlimited@3x.png'
import { keepTwodecimalFixed, isAndroid } from '../../utils/util'
export default {
    name: 'CouponGoodsList',
    components: {
        Flexbox,
        FlexboxItem
    },
    data(){
        return {
            couponGoodsList:[],
        }
    },
    mounted(){
        this.httpGetUsePackage()
    },
    methods:{
        goBack() {
            this.$router.go(-1)
        },
        itemClickHandler(row,isResplace) {
            if(isResplace){
                this.$router.replace(this.$setRouteQuery({
                    name: 'PackageDetail',
                    query: {
                        goodsCode: row.goodsCode,
                        categoryCode: row.categoryCode,
                        goodsType: row.goodsType,
                        souce:'优惠券可使用套餐列表',
                        promotionCode: this.$route.query.promotionCode
                    }                 
                },this));
                return;
            }
            this.$router.push(this.$setRouteQuery({
                name: 'PackageDetail',
                query: {
                    goodsCode: row.goodsCode,
                    categoryCode: row.categoryCode,
                    goodsType: row.goodsType,
                    souce:'优惠券可使用套餐列表',
                    promotionCode: this.$route.query.promotionCode
                }                 
            },this));
        },
        // 接口查询可用套餐
        httpGetUsePackage() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData) || {};
                this.$http.post({
                    url:"/bss/app/promotion/getGoodsListBypromotionCode",
                    data: {
                        channelType: this.$APP_CONFIG.request.channelType,
                        promotionCode: this.$route.query.promotionCode,
                        loginCustomerId: sessionStorageUrlData.loginCustomerId,
                        params:{queryVipDayFlag:1},
                        queryLimitFlag:1,
                        queryPromotionFlag:1,
                        showFlowFlag:1,
                    }
                }).then(res => {
                    if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                        let list = res.data.dataList.filter(item => {
                            return !item.attrMap?.buyTerminalType || item.attrMap?.buyTerminalType.includes(sessionStorageUrlData.terminalType);
                        });
                        this.couponGoodsList = this.initLocalPackageData(list);  

                        // 单个商品直接跳转详情页
                        if(this.couponGoodsList && this.couponGoodsList.length === 1){
                            this.itemClickHandler(this.couponGoodsList[0],true);
                        }

                        // 批量计算优惠券后的价格
                        if(this.couponGoodsList && this.couponGoodsList.length > 1){
                            this.e_preCalcOrder(this.couponGoodsList);
                        }
                    }   
                }).catch(err => {
                    this.$toast(err);
                    console.log(err);
                });
        },
        //预计算价格，如果优惠后total=0则只能使用余额支付
        e_preCalcOrder(list){
            let selectedCoupon = JSON.parse(sessionStorage.getItem('data-selectedCoupon') || "{}");
            list.forEach(item => {
                if(['LXCX'].includes(item.categoryCode) && item?.attrMap.payAgreeFlag == '1') return;
                let cutPrice = 0;
                if(['P01','P03'].includes(selectedCoupon.promotionMode)){
                    cutPrice = (+item.goodsPrice) * (selectedCoupon.quota / 100);
                } else {
                    cutPrice = selectedCoupon.quota * 100;
                }
                let price = +item.goodsPrice - cutPrice > 0 ? +item.goodsPrice - cutPrice : 0;
                if(['P01','P02'].includes(selectedCoupon.promotionMode) && +item.goodsPrice >= +selectedCoupon.fullCut * 100) {
                   if(price < this.getMinPrice(item)) this.doPriceStyle(item, price, 'goodsPriceText');
                } else if(['P03','P04'].includes(selectedCoupon.promotionMode)) {
                   if(price < this.getMinPrice(item))  this.doPriceStyle(item, price, 'goodsPriceText');
                }
            });
        },
        initLocalPackageData(list) {                
                let newList = [];
                for(let i = 0;i < list.length;i++) {                    
                    let item  = list[i];
                    item.goodsPrice = +item.goodsPrice + "";

                    // 页面只显示DISC、PKAG
                    if(item.goodsType != 'DISC' && item.goodsType != 'PKAG') {
                        continue;
                    }
                    // 过滤黑名单
                    if(item.mccFlag && item.mccFlag == 'BLACK') {
                        continue;
                    }
                    // 过滤掉用户自定义
                    if(item.attrMap.effType == 'USER_DEFINED') {
                        continue;
                    }
                    // 过滤掉DIY
                    if((item.goodsType == 'DISC' && item.categoryCode == 'GDIY') || (item.goodsType == 'PKAG' && item.attrMap.pkType == 'DIY')) {
                        continue;
                    }
                    // 过滤掉CZME
                    if(item.categoryCode && item.categoryCode == 'CZME') {
                        continue;
                    }
                    // 过滤DSDS
                    /*
                    if(item.terminalType == 'DSDS') {
                        continue;
                    }
                    */
                    
                    item.item_bg = unlimited_bg;
                    if(item.goodsType == 'DISC') {
                        item.item_bg = unlimited_bg;
                    } else if(item.goodsType == 'PKAG') {
                        item.item_bg = normal_bg;
                    }
                    
                    // 处理价格
                    item.listPriceShow = false;
                    item.vipPriceShow = false;
                    if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                        // vip会员日并且最低价是discountPrice
                        if(item.vipAct && item.vipAct === '1' && this.minPriceIsDiscountPrice(item)) {
                            this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                            this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                            item.vipPriceShow = true;
                        } else {
                            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
                            if(autoRenewFirstPrice > 0 && autoRenewFirstPrice < item.goodsPrice) {
                                this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                                item.listPriceShow = true;
                                this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                            } else {
                                this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                            }
                        }
                    } else {
                        // vip 会员日
                        if(item.vipAct && item.vipAct === '1') {
                            this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                            this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                            item.vipPriceShow = true;
                        } else {
                            this.doPriceStyle(item, item.discountPrice !== null ? item.discountPrice : item.goodsPrice, 'goodsPriceText');
                            if(item.discountPrice != null) {
                                this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                                item.listPriceShow = true;
                            }
                        }
                    }
                    //生成角标
                    this.genSaleIcon(item);

                    // multi region packages
                    if(item.iso2List && (item.iso2List.length > 1 || item.iso2List[0] == 'ALL')) {                 
                        item.multiRegionFlag = true;
                    } else if (item.goodsType == 'DISC') {
                        if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                            item.unlimitedFlag = true;
                            this.doUnlimitedPackages(item);
                        }
                    } else if(item.goodsType == 'PKAG') {
                        if(item.attrMap.pkType != 'DIY') {
                            item.normalFlag = true;
                            this.doNormalPackages(item)
                        }
                    }

                    newList.push(item);
                }
                
                return newList;
        },
        genSaleIcon(item) {
            /*
            * sale icon
            * */
            item.saleTextShow = false;
            item.saleIconShow = false;
            let _w = 'auto';
            if(isAndroid()) {
                /*
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2 || Math.floor(window.devicePixelRatio) == 3) {
                    _w = `${(100*2)/3}%`;
                }
                */
            } else {
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2) {
                    _w = `${(100*2)/3}%`;
                }
            }
            item.saleIconStyle = {
                width: _w
            };
            let saleImageUrl = '';
            // 获取图标
            if(item.cornerMark != null && Object.values(item.cornerMark).length > 0 && Object.values(item.cornerMark).some(val => val != '')) {
                if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                    saleImageUrl = item.cornerMark[item.deductionInfo.autoRenewActCode];
                } else {
                    saleImageUrl = item.cornerMark[item.promotionActivityCode];
                }
            } else if(item.iconInfos && item.iconInfos.length > 0) {
                saleImageUrl = item.iconInfos[0].attrValue;
            }
            // 判断图标是否为空
            if(saleImageUrl) {
                item.saleImageUrl = saleImageUrl;
                item.saleIconShow = true;
            }
            let img = new Image(),iconStyle = {};
            img.addEventListener('load', () => {
                if(img.width >= this.boxItemWidth) {
                    iconStyle = {width: '100%'};
                } else {
                    iconStyle = {width: 'auto'};
                }
                this.$set(item,'iconStyle',iconStyle);
            },false)

            if(item.saleImageUrl){
                img.src = item.saleImageUrl;    
            }
            
        },
        doPriceStyle(item, price, key) {
            //price = keepTwodecimalFull(price/100);
            //item[key] = `${item.currencyType} ${price}`;
            item[key] = this.globalPriceFormat(item.currencyType, price);                
        },
        minPriceIsDiscountPrice(item) {
            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
            let autoRenewPrice = item.deductionInfo.autoRenewPrice ? item.deductionInfo.autoRenewPrice : 0.0;
            let discountPrice = item.discountPrice ? item.discountPrice : 0.0;
            if(autoRenewPrice > discountPrice && autoRenewFirstPrice > discountPrice) {
                return true;
            }
            return false;
        },
        getMinPrice(item) {
            let prices = [];

            if(item.deductionInfo?.autoRenewFirstPrice) {
                prices.push(item.deductionInfo.autoRenewFirstPrice);
            }
            if(item.deductionInfo?.autoRenewPrice) {
                prices.push(item.deductionInfo.autoRenewPrice);
            }
            if(item.discountPrice) {
                prices.push(item.discountPrice);
            }
            if(item.goodsPrice) {
                prices.push(item.goodsPrice);
            }

            return Math.min(...prices);
        },
        doUnlimitedPackages(item) {
            this.genName(item);
            // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
            item.high_speed_text = this.$t('packages.high_speed_text');
            let billInfo = item.billingInfos;
            if(billInfo && billInfo.length > 0) {
                if(billInfo[0].periodUnit === 0) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                        }
                    }

                } else if(billInfo[0].periodUnit === 1) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitSimp.day')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                        }
                    }

                } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                        }
                    }
                } else if(billInfo[0].periodUnit === 3) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                        }
                    }
                }
            }

            if(item.categoryCode == 'BTTC' || (item.categoryCode == 'LXCX' && item.periodUnit == 'DAY')) {
                item.goodsNameStr = this.$t('packages.unlimited_good_name.day');

            } else if (item.categoryCode == 'BYTC' || item.categoryCode == 'SWBY' || (item.categoryCode == 'LXCX' && item.periodUnit == 'MONTH')) {
                if(item.period && item.period == 12) {
                    item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                } else {
                    if(item.attrmap && item.attrmap.period && item.attrmap.period == 12) {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                    } else {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.month');
                    }
                }
            }
        },
        //处理普通包有效期
        doNormalPackagesCycle(item) {
            let expireToday = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_DAY',
                expireThisMonth = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_MONTH',
                effectiveImmediately = item.goodsType == 'DISC' && item.attrMap.effType == 'IMMEDIATELY',
                effectiveMarrow = item.goodsType == 'DISC' && item.attrMap.effType == 'MARROW',
                effectiveNextMonth = item.goodsType == 'DISC' && item.attrMap.effType == 'NEXT_MONTH';

            if(expireToday || expireThisMonth) {
                item.period = expireToday ? `${this.$t('packages.day_invalid')}` : `${this.$t('packages.month_invalid')}`
            } else {
                if(item.period) {
                    let singleUnit = this.$t(`packages.periodUnit.${item.periodUnit.toLowerCase()}`),
                        multipleUnit = this.$t(`packages.periodUnits.${item.periodUnit.toLowerCase()}`);
                    item.period = item.period > 1 ? `${item.period} ${multipleUnit}` : `${item.period} ${singleUnit}`;
                    if(effectiveImmediately) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.immediate_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.immediate_valid')})`;
                    } else if(effectiveMarrow) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_day_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_day_valid')})`;
                    } else if(effectiveNextMonth) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_month_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_month_valid')})`;
                    }
                }
            }
        },
        doNormalPackages(item) {
            this.genName(item);
            this.doNormalPackagesCycle(item);
        },
        genName(item) {
            let flow = (item.billingInfos && item.billingInfos.length > 0) ? item.billingInfos[0].flow : item.flowByte;
            if(flow > 0) {
                if(flow > 1000) {
                    flow = flow/1024;
                    // 判断是不是整数
                    if(Math.floor(flow) === flow) {
                        item.goodsName_H5_tag = `${flow}GB`;
                    } else {
                        item.goodsName_H5_tag = `${keepTwodecimalFixed(flow)}GB`;
                    }
                } else {
                    item.goodsName_H5_tag = `${flow}MB`;
                }
            } else {
                item.goodsName_H5_tag = `0MB`;
            }
        },
    }
}
</script>

<style lang="less" scoped>
.CouponGoodsList {
    background-color: #f2f2f2;
    min-height: 100vh;
    min-height: 100dvh;
    .couponsGoodList-head {
        background: transparent;
        ::v-deep .left {
            .van-icon {
                color: #fff;
            }
        }
    }
    .couponGoodsList-head-con {
        position: relative;
        background: url(../../assets/imgs/coupons/coupons-bg.png) no-repeat;
        background-size: 100% 100%;
        height: 150px;
        .couponGoodsList-head-bg {
            margin-top: 28px;
            color: #FF8000;
            font-size: 14px;
            width: 100%;
            text-align: center;
            .couponGoodsList-head-title {
                width: 216px;
                margin: auto;
                min-height:56px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .goodsList {
        .no-data {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding-top: 70px;
            img {
                width: 160px;
                height: 104px;
            }
            .tips-noData {
                font-weight: 700;
                font-size: 14px;
                margin-top: 14px;
            }
        }
        padding: 0 12px;
        .goodsList-name {
            color: #666;                            
        }
        [class*='van-hairline']::after {
            border-color: #999;
            border-radius: 2px;                        
        }
        .van-hairline--surround::after {
            border-width: 0.5px;
        }
        .unlimited-desc, .goodsList-period {
            display: inline-flex;            
            font-size: 10px;
            color: #999;            
            margin: 6px 0 24px;
            //border: 1px solid #999;
            border-radius: 2px;
            line-height: 14px;
            padding: 1.5px 6px;
        }
        .goodsList-price-box {
            line-height: 18px;
            position: absolute;
            left: 12px;
            bottom: 10px;
            display: flex;
            .price {
                // font-family: Roboto-Medium;
                font-size: 18px;
                color: #F74E4E;
                letter-spacing: 0;
            }
            .list-price {
                position: relative;
                left: 4px;
                top: 1px;
                font-size: 8px;
                color: #999999;
                text-decoration: line-through;
            }
            .vip-price {
                display: inline-block;
                height: 15px;
                line-height: 15px;
                font-size: 10px;
                
                i {
                    display: inline-block;
                    height: 100%;
                    width: 22px;
                    background-image: linear-gradient(225deg, #5C5C5C 0%, #333333 100%);
                    border-radius: 2px 0 0 2px;
                    position: relative;
                    img {
                        width: 60%;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                .vip-price-value {
                    padding: 0 8px 0;
                    height: 100%;
                    display: inline-block;
                    text-align: center;
                    border: 1px solid #979797;
                    border-left: none;
                    border-radius: 0 2px 2px 0;
                }
            }
        }
    }
}
html[dir='rtl'] .CouponGoodsList{
    .goodsList {
        .goodsList-price-box {
            left: unset;
            right: 12px;
            .list-price {
                left: -2px;
            }
        }
    }
}
</style>